import { Action, AnyAction, ReducersMapObject } from 'redux';

import {
    createModuleManager,
    createReducerManager,
    createServiceRegistry,
    ErrorReporterService,
} from '@mews/framework';

export const configureModuleManager = <S extends Record<string, unknown> = {}, A extends Action = AnyAction>({
    initialReducers,
    errorReporterService,
}: {
    initialReducers: ReducersMapObject<S, A>;
    errorReporterService: ErrorReporterService;
}) => {
    const reducerManager = createReducerManager(initialReducers);
    const serviceRegistry = createServiceRegistry();

    return createModuleManager({
        reducerManager,
        serviceRegistry,
        errorReporterService,
    });
};
